import React, { FC, useEffect } from 'react';
import { ThemeProvider } from '@material-ui/styles';
import retailTheme from 'config/themes/retailTheme';
import { Box, CssBaseline, withStyles } from '@material-ui/core';
import DarkFlowerWrapper from 'components/common/structures/Wrappers/DarkFlowerWrapper';
import { Router } from 'next/router';
import Metadata, { MetadataInterface } from 'containers/common/sections/Metadata';
import EvcAdapter from 'components/adapters/EvcAdapter';
import Footer from 'evcharging/containers/layout/Footer';

interface RetailThemeProps extends MetadataInterface {
  disablePaddingBottom?: boolean;
}

const StyledBox = withStyles(() => ({
  root: {
    backgroundColor: '#F7F8FA',
    '-webkit-overflow-scrolling': 'touch',
  },
}))(Box);

const RetailTheme: FC<RetailThemeProps> = (props) => {
  const { children, disablePaddingBottom = false, ...metadataProps } = props;
  useEffect(() => {
    Router.events.on('routeChangeComplete', () => {
      window.scrollTo(0, 0);
    });
  }, []);

  return (
    <>
      <Metadata {...metadataProps} />
      <ThemeProvider theme={retailTheme}>
        <CssBaseline />
        <StyledBox>
          <DarkFlowerWrapper disablePaddingBottom={disablePaddingBottom}>
            {children}
          </DarkFlowerWrapper>
        </StyledBox>
        <EvcAdapter>
          <Footer />
        </EvcAdapter>
      </ThemeProvider>
    </>
  );
};

export default RetailTheme;
